<script setup lang="ts">
import { computed } from 'vue'
import { useFrameStore } from '../stores/frameStore'

const frameStore = useFrameStore()

const isVisible = computed(() => frameStore.isInfoLabelVisible)
const text = computed(() => frameStore.infoLabelText)
const position = computed(() => frameStore.infoLabelPosition)
</script>

<template>
  <div
    v-if="isVisible"
    class="info-label fixed px-3 py-2 rounded text-white text-xs font-medium pointer-events-none shadow-lg"
    :style="{
      left: position.x + 'px',
      top: position.y + 'px',
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      fontFamily: 'Monaco, Courier New, monospace',
      zIndex: 3000,
    }"
  >
    {{ text }}
  </div>
</template>

<style scoped>
.info-label {
  white-space: nowrap;
}
</style>
